import { Chart, ChartTypes } from "@uicore";
import { Card, CardContent, CardTitle, IconButton, Stack } from "@altimateai/lego";
import { Cell, Pie, TooltipProps } from "recharts";
import { IconInfoCircle } from "@tabler/icons-react";
import classes from "../../../summary/summary.module.scss";
import SavingsPieTooltip, {
  SAVINGS_PIE_COLORS,
} from "../../../summary/components/SavingsPieTooltip";
import type { SavingsData } from "../types";

interface Props {
  isFuture: boolean;
  savings: SavingsData;
}

const DatabricksSavingsChart = ({ isFuture, savings }: Props) => {
  const graphData = [
    { name: "total_autonomous_savings", label: "Autonomous", value: savings.autonomous },
    { name: "total_assisted_savings", label: "Assisted", value: savings.assisted },
  ];

  return (
    <>
      <Card className="al-p-4 al-flex-1 al-max-w-[50%]">
        <CardTitle>
          <Stack align="center" justify="between">
            <span>{isFuture ? "Money Savings Per Month" : "Money Savings"}</span>
            <IconButton
              variant="ghost"
              title={
                isFuture ? "Breakdown of projected savings by type" : "Breakdown of savings by type"
              }
            >
              <IconInfoCircle size={16} />
            </IconButton>
          </Stack>
        </CardTitle>
        <CardContent>
          <Chart
            type={ChartTypes.PieChart}
            data={graphData}
            xAxisDataKey="name"
            title="Money Savings"
            hideFullscreenButton
            height={350}
            tooltipProps={{
              content: (props: TooltipProps<number, string>) => (
                <SavingsPieTooltip
                  {...props}
                  data={{
                    total: savings.total,
                    autonomous: savings.autonomous,
                    assisted: savings.assisted,
                  }}
                />
              ),
            }}
          >
            {() => (
              <Pie dataKey="value" data={graphData} fill="#247EFE">
                {graphData.map((entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={SAVINGS_PIE_COLORS[index % SAVINGS_PIE_COLORS.length]}
                    name={entry.label}
                  />
                ))}
              </Pie>
            )}
          </Chart>
        </CardContent>
      </Card>
      <Card className={`${classes.donutChart} al-flex-1 al-max-w-[50%]`}>
        <CardTitle>
          <Stack align="center" justify="between">
            <span>{isFuture ? "Time Savings Per Month" : "Time Savings"}</span>
            <IconButton
              variant="ghost"
              title={isFuture ? "Projected time that could be saved" : "Time that could be saved"}
            >
              <IconInfoCircle size={16} />
            </IconButton>
          </Stack>
        </CardTitle>
        <CardContent className="al-mt-12">
          <div className={classes.donut}>{savings.timeSaved.toLowerCase()}</div>
        </CardContent>
      </Card>
    </>
  );
};

export default DatabricksSavingsChart;
